// sensei-app/client/widgets/CourseProgressWidget.widget.js
export default {
    name: "CourseProgressWidget",
    type: "DataWidget",
    description: "Shows progress for all enrolled courses.",
    roles: ["student"],
    widget: {
        title: "My Course Progress",
        size: "large",
        // --- FIX: Add dataProvider with a transform function ---
        dataProvider: {
            main: {
                rpc: "StudentCourseRpc.getData",
                // The RPC returns { data: [...] }, so we extract the array.
                transform: (response) => response?.data || []
            }
        },
        viewMode: "list",
        fields: [
            { name: 'title', label: 'Course', render: (val) => `<strong>${val}</strong>` },
            {
                name: 'progress',
                label: 'Progress',
                render: (progress, item, widget) => {
                    if (!progress) {
                        return `<span class="badge bg-secondary">${widget.t('Not Started')}</span>`;
                    }
                    
                    // Calculate total possible marks from mandatory topics
                    const totalMarks = (item.topics || [])
                        .filter(t => t.isMandatory)
                        .reduce((sum, t) => sum + (t.marks || 0), 0);

                    const percentage = totalMarks > 0 ? Math.round((progress.totalScore / totalMarks) * 100) : 0;

                    let statusBadge = '';
                    if (progress.hasPassed) {
                        statusBadge = `<span class="badge bg-success">${widget.t('Passed')}</span>`;
                    } else if (progress.isCompleted) {
                        statusBadge = `<span class="badge bg-warning text-dark">${widget.t('Completed')}</span>`;
                    } else {
                        statusBadge = `<span class="badge bg-info">${widget.t('In Progress')}</span>`;
                    }

                    // Return a more detailed HTML structure
                    return `
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            ${statusBadge}
                            <small class="text-muted">${progress.totalScore} / ${totalMarks} Marks</small>
                        </div>
                        <div class="progress" role="progressbar" aria-label="Course progress" aria-valuenow="${percentage}" aria-valuemin="0" aria-valuemax="100" style="height: 8px;">
                            <div class="progress-bar" style="width: ${percentage}%"></div>
                        </div>
                    `;
                }
            }
        ],
        noDataMessage: "You are not enrolled in any courses yet."
    }
};